import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatPaginator,
  PageEvent,
} from '@angular/material/paginator';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import {
  MatSort,
} from '@angular/material/sort';
import {
  MatTableDataSource,
} from '@angular/material/table';
import {
  Router,
} from '@angular/router';
import {
  DatePipe,
} from '@angular/common';
import {
  Page,
} from 'src/app/model/Page';
import {
  ExportImportService,
} from 'src/app/services/export-import.service';
import {
  MasterService,
} from 'src/app/services/master.service';
import {
  ReportService,
} from 'src/app/services/report.service';
import {
  ApplicantStatusService,
} from 'src/app/services/Applicant-Status.service';
import {
  ApplicantListModel,
} from 'src/app/services/ApplicantListModel';
import {
  SelectionModel,
} from '@angular/cdk/collections';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppointmentApproveComponent } from './approve-case/appointment-approve-case.component';

import { MatDialog } from '@angular/material/dialog';
import { ModalController } from '@ionic/angular';
import { AppointmentRejectComponent } from './reject-case/appointment-reject-case.component';
import { RescheduledAppointmentComponent } from './RescheduledAppointment/RescheduledAppointment.component';
import { ForwardAnotherAuthorityComponent } from './forward-another-authority-case/forward-another-authority-case.component';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'app-secure-apointment',
  templateUrl: './apointment.component.html',
  styleUrls: ['./apointment.component.scss'],
})
export class apointmentComponent implements OnInit {
  isLoading: boolean = false;
  lotteryList: { [key: number]: string };
  boardValue: boolean = false;
  lotteryValue: boolean = false;
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  boards: { [key: number]: string };
  board: any;
  lottery: any;
  startDate: any;
  endDate: any;
  schemeList: { [key: number]: string };
  scheme: any;
  selectedApplicationNumbers: string[] = [];
  count: string;
  remark: string;
  selectedOfficerKey:any;
  selectedSlotKey: any;
  progressSpinnerDialog: any = null;
  page: Page<ApplicantListModel>;
  dataSource: MatTableDataSource<ApplicantListModel> =
    new MatTableDataSource();
  selection = new SelectionModel<ApplicantListModel>(true, []);
  selectedAppointments: string[] = [];
  appointmentId: String;

  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    'select', // Add the select column
    'id',
    'appointmentId',
    'applicantName',
    'appointment_date',
    'appointment_time',
    'mobileNumber',
    'appointmentStatus',
    'action',
  ];
  pageSizeOptions: number[] = [10, 25, 100, 200, 400];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  statusList: any[] = [
    { name: 'ALL STATUS', value: 'TOTAL' },
    { name: 'PENDING', value: 'PENDING' },
    { name: 'APPROVED', value: 'APPROVED' },
    { name: 'REJECTED', value: 'REJECTED' },
    { name: 'FORWARDED', value: 'FORWARDED' },
    { name: 'RESCHEDULED', value: 'RESCHEDULED' },
  ];
  loaded: boolean;
  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService: ReportService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private masterService: MasterService,
    private ApplicantStatusService: ApplicantStatusService,
    private dialog: MatDialog,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem('app-secure-view-application-filterText'),
        [Validators.required, Validators.minLength(3)]
      ),
      applicantStatus: new FormControl(
        localStorage.getItem('applicant-status') || 'TOTAL'
      ),
    });
    this.filterForm.controls['filterText'].setValue(null);

    // Apply the search filter
    this.dataSource.filterPredicate = (data: ApplicantListModel, filter: string) => {
      return data.applicantName.toLowerCase().includes(filter) || 
             data.appointmentId.toString().includes(filter);
    };

    this.filterForm.controls['filterText'].valueChanges
      .pipe(tap(filterValue => this.applyFilter(filterValue)))
      .subscribe();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onStatusChange(value: any) {
    this.statusId = value;
    this.loaded = false;
    localStorage.setItem('applicant-status', this.statusId);
    this.selection.clear();
    this.selectedAppointments = [];
    this.loadData();
  }
  
  isButtonVisible(status: string): boolean {
    return this.statusId === status;
  }
  loadData() {
    this.ApplicantStatusService.getApplicantList(
      localStorage.getItem('applicant-status'),
      this.currentPage,
      this.pageSize,
      this.filterForm.value.filterText
    ).subscribe(
      (page: any) => {
        this.loaded = true;
        this.page = page;
        this.dataSource = new MatTableDataSource(page.content || []);
        
        // Update selection state based on current data
        this.dataSource.data.forEach(row => {
          if (this.selectedAppointments.includes(row.appointmentId.toString())) {
            this.selection.select(row);
          }
        });
  
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.totalElements;
        });
        this.isSearchDisabled = false;
      },
      (error) => {
        console.log(error);
        this.isSearchDisabled = false;
      }
    );
  }
  

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
    this.selection.clear(); // Clear selection when page changes
  }
  

  toggleSelection(appointmentId: number): void {
    const appointmentIdStr = appointmentId.toString();
    const index = this.selectedAppointments.indexOf(appointmentIdStr);
    
    if (index > -1) {
      this.selectedAppointments.splice(index, 1);
      this.selection.deselect(this.dataSource.data.find(d => d.appointmentId === appointmentId));
    } else {
      this.selectedAppointments.push(appointmentIdStr);
      this.selection.select(this.dataSource.data.find(d => d.appointmentId === appointmentId));
    }
  }
  
  
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  

  isIndeterminate() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected > 0 && numSelected < numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      // Deselect all rows on the current page
      this.dataSource.data.forEach(row => {
        this.selection.deselect(row);
        const index = this.selectedAppointments.indexOf(row.appointmentId.toString());
        if (index > -1) {
          this.selectedAppointments.splice(index, 1);
        }
      });
    } else {
      // Select all rows on the current page
      this.dataSource.data.forEach(row => {
        if (!this.selection.isSelected(row)) {
          this.selection.select(row);
          const appointmentIdStr = row.appointmentId.toString();
          if (!this.selectedAppointments.includes(appointmentIdStr)) {
            this.selectedAppointments.push(appointmentIdStr);
          }
        }
      });
    }
  }
  

  selectionToggle(element: ApplicantListModel) {
    this.selection.toggle(element);
    this.toggleSelection(element.appointmentId); // Convert to string
  }

  hasSelected() {
    return this.selection.selected.length > 0;
  }

  async approveSelected() {
    const modal = await this.modalCtrl.create({
      component: AppointmentApproveComponent,
      componentProps: {
        appointmentId: this.selectedAppointments.join(','),
      },
    });
    await modal.present(); // Open modal
  
    const { data, role } = await modal.onWillDismiss(); // Wait for modal dismissal
  
    if (role === "approve") {
      this.displayProgressSpinner(); // Start spinner after modal is closed
  
      this.ApplicantStatusService
        .approveAppointment(
          this.selectedAppointments.join(','), 
          data
        )
        .subscribe(
          (response) => {
            this.loadData();
            this.router.navigate(['/secure/apointmentList']);
            this._snackBar.open("Appointment Request Accepted", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3000,
            });
          },
          (error) => {
            // Handle error
            this._snackBar.open("Error: Could not approve the appointment", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "error-toast",
              duration: 3000,
            });
          },
          () => {
            this.progressSpinnerDialog.close(); // Stop spinner after API call completes
          }
        );
    }
  }
  
  async rejectSelected() {
    const modal = await this.modalCtrl.create({
      component: AppointmentRejectComponent,
      componentProps: {
        appointmentId: this.selectedAppointments.join(','),
      },
    });
    
    await modal.present(); // Open modal
  
    const { data, role } = await modal.onWillDismiss(); // Wait for modal to be dismissed
  
    if (role === "reject") {
      this.displayProgressSpinner(); // Start spinner
  
      console.log("DATA", data);
      this.ApplicantStatusService
        .rejectedAppointment(this.selectedAppointments.join(','), data, "REJECTED")
        .subscribe(
          (response) => {
            console.log(response, "fromStatus files API");
            this.loadData();
            this.router.navigate(['/secure/apointmentList']);
            this._snackBar.open("Appointment Request REJECTED", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "danger-toast",
              duration: 3000,
            });
          },
          (error) => {
            // Handle error
            this._snackBar.open("Error: Could not reject the appointment", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "error-toast",
              duration: 3000,
            });
          },
          () => {
            this.progressSpinnerDialog.close(); // Stop spinner after API call completes
          }
        );
    }
  }
  

  async rescheduledSelected() {
    const modal = await this.modalCtrl.create({
      component: RescheduledAppointmentComponent,
      componentProps: {
        appointmentId: this.selectedAppointments.join(','),
        remark: this.remark,
        selectedOfficerKey: this.selectedOfficerKey
      },
    });
    
    await modal.present(); // Open modal
  
    const { data, role } = await modal.onWillDismiss(); // Wait for modal dismissal
  
    if (role === "Reschedule") {
      this.displayProgressSpinner(); // Start spinner after modal is closed
  
      this.selectedSlotKey = data.selectedSlotKey;
      this.remark = data.forwardReason;
  
      console.log("DATA", data);
      console.log("Remark", this.remark);
  
      this.ApplicantStatusService
        .RescheduleAppointment(
          this.selectedAppointments.join(','), 
          this.selectedSlotKey,
          this.remark
        )
        .subscribe(
          (response) => {
            console.log(response, "fromStatus files API");
            this.loadData();
            this.router.navigate(['/secure/apointmentList']);
            this._snackBar.open("Appointment Rescheduled Successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3000,
            });
          },
          (error) => {
            // Handle error
            this._snackBar.open("Error: Could not reschedule the appointment", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "error-toast",
              duration: 3000,
            });
          },
          () => {
            this.progressSpinnerDialog.close(); // Stop spinner after API call completes
          }
        );
    }
  }
  

  async forwardSelected() {
    const modal = await this.modalCtrl.create({
      component: ForwardAnotherAuthorityComponent,
      componentProps: {
        appointmentId: this.selectedAppointments.join(','),
        remark: this.remark,
        selectedOfficerKey: this.selectedOfficerKey
      },
    });
    
    await modal.present(); // Open modal
  
    const { data, role } = await modal.onWillDismiss(); // Wait for modal dismissal
  
    if (role === "forward") {
      this.displayProgressSpinner(); // Start spinner after modal is closed
  
      this.selectedOfficerKey = data.selectedOfficerKey;
      this.selectedSlotKey = data.selectedSlotKey;
      this.remark = data.forwardReason;
  
      console.log("DATA", data);
      console.log("selectedOfficerKey", this.selectedOfficerKey);
      console.log("Remark", this.remark);
  
      this.ApplicantStatusService
        .forwardAppointment(
          this.selectedAppointments.join(','), 
          this.selectedOfficerKey,
          this.selectedSlotKey,
          this.remark
        )
        .subscribe(
          (response) => {
            console.log(response, "fromStatus files API");
            this.loadData();
            this.router.navigate(['/secure/apointmentList']);
            this._snackBar.open("Appointment Forwarded Successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "danger-toast",
              duration: 3000,
            });
          },
          (error) => {
            // Handle error
            this._snackBar.open("Error: Could not forward the appointment", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "error-toast",
              duration: 3000,
            });
          },
          () => {
            this.progressSpinnerDialog.close(); // Stop spinner after API call completes
          }
        );
    }
  }
  
  refreshPage(): void {
    window.location.reload();
  }
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
}
